import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, inject } from '@angular/core';
import { type IconDefinition, type IconName } from '@fortawesome/fontawesome-common-types';

@Component({
  selector: 'top-nav-item',
  template: `
    <ng-content>
      @if (iconTyped) {
        <fa-icon [icon]="iconTyped" size="lg"></fa-icon>
      } @else if (icon) {
        <fa-icon [icon]="['far', icon]" size="lg"></fa-icon>
      }
      @if (label) {
        <span class="nav-item-label">
          {{ label }}
        </span>
      }
    </ng-content>
  `,
  styleUrls: ['./top-nav-item.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TopNavItemComponent {
  elementRef = inject(ElementRef);

  @Input()
  label: string;

  @Input()
  iconTyped: IconDefinition;

  @Input()
  icon: IconName;

  // turns off padding, to have a child component fill the entire nav-item
  // and get click events no matter where on the top-nav is clicked.
  @Input()
  @HostBinding('class.no-padding')
  noPadding = false;
}
